import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Link } from "react-router-dom";
import Moment from "react-moment";

function Blog({ blogData, id }) {
  const {
    title,
    urlTitle,
    date,
    author,
    avatar: {
      data: {
        attributes: { url },
      },
    },
    tag: {
      data: {
        attributes: { label },
      },
    },
  } = blogData;
  const getNospaceTitle = (filesource) => {
    let tempArr = filesource.split("/");
    let fileName = tempArr[tempArr.length - 1];
    let getName = fileName.slice(0, -3);
    return getName;
  };
  const baseUrl = "https://lawful-space-production.up.railway.app";
  return (
    <AnimationOnScroll
      animateIn="animate__fadeInUp"
      animateOut="animate__fadeOutDown"
      animateOnce={true}
    >
      <div className="blog-item rounded bg-white shadow-dark">
        <div className="thumb">
          <a href="!#">
            <span className="category">{label}</span>
          </a>
          <Link to={`blog/${id}/${urlTitle}`}>
            <img src={baseUrl + url} alt={urlTitle} />
          </Link>
        </div>
        <div className="details">
          <h4 className="my-0 title">
            <Link to={`blog/${id}/${urlTitle}`}>{title}</Link>
          </h4>
          <ul className="list-inline meta mb-0 mt-2">
            <li className="list-inline-item">
              <Moment format="DD-MM-YYYY HH:mm:ss">{date}</Moment>
            </li>
            <li className="list-inline-item">{author}</li>
          </ul>
        </div>
      </div>
    </AnimationOnScroll>
  );
}

export default Blog;
